// Mock services data for development and testing
// This file contains sample data that should be replaced with actual API calls

export const mockServices = [
  {
    id: '1',
    title: 'تصميم شعار احترافي',
    description: 'تصميم شعار احترافي يعكس هوية علامتك التجارية بأسلوب عصري وجذاب',
    price: 500,
    deliveryTime: 3,
    rating: 4.8,
    reviewsCount: 124,
    image: 'https://images.unsplash.com/photo-1626785774573-4b799315345d?w=400',
    supplier: {
      id: 's1',
      name: 'أحمد المصمم',
      avatar: 'https://i.pravatar.cc/150?img=1',
      isVerified: true,
    },
    categoryId: 'design',
  },
  {
    id: '2',
    title: 'تطوير موقع إلكتروني',
    description: 'تطوير موقع إلكتروني متكامل باستخدام أحدث التقنيات',
    price: 3000,
    deliveryTime: 14,
    rating: 4.9,
    reviewsCount: 89,
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400',
    supplier: {
      id: 's2',
      name: 'سارة المطورة',
      avatar: 'https://i.pravatar.cc/150?img=5',
      isVerified: true,
    },
    categoryId: 'development',
  },
  {
    id: '3',
    title: 'كتابة محتوى تسويقي',
    description: 'كتابة محتوى تسويقي جذاب لمواقع التواصل الاجتماعي',
    price: 800,
    deliveryTime: 5,
    rating: 4.7,
    reviewsCount: 156,
    image: 'https://images.unsplash.com/photo-1455390582262-044cdead277a?w=400',
    supplier: {
      id: 's3',
      name: 'محمد الكاتب',
      avatar: 'https://i.pravatar.cc/150?img=3',
      isVerified: false,
    },
    categoryId: 'content',
  },
];

export const mockCategories = [
  { id: 'design', label: 'تصميم', count: 45 },
  { id: 'development', label: 'برمجة وتطوير', count: 32 },
  { id: 'content', label: 'كتابة محتوى', count: 28 },
  { id: 'marketing', label: 'تسويق', count: 19 },
  { id: 'video', label: 'فيديو وصوت', count: 15 },
];

export const mockService = {
  id: '1',
  title: 'تصميم شعار احترافي',
  description:
    'تصميم شعار احترافي يعكس هوية علامتك التجارية بأسلوب عصري وجذاب. يشمل التصميم 3 مفاهيم أولية، مراجعتين مجانيتين، وتسليم الملفات بجميع الصيغ المطلوبة.',
  price: 500,
  deliveryTime: 3,
  rating: 4.8,
  reviewsCount: 124,
  images: [
    'https://images.unsplash.com/photo-1626785774573-4b799315345d?w=800',
    'https://images.unsplash.com/photo-1561070791-2526d30994b5?w=800',
    'https://images.unsplash.com/photo-1572044162444-ad60f128bdea?w=800',
  ],
  supplier: {
    id: 's1',
    name: 'أحمد المصمم',
    avatar: 'https://i.pravatar.cc/150?img=1',
    isVerified: true,
    rating: 4.9,
    completedProjects: 245,
  },
  features: [
    '3 مفاهيم تصميم أولية',
    'مراجعتين مجانيتين',
    'ملفات بصيغ متعددة (AI, PNG, SVG, PDF)',
    'دليل استخدام الشعار',
    'دعم فني لمدة شهر',
  ],
  category: 'تصميم',
};

// Mock search results
export const mockSearchResults = {
  services: [
    {
      id: 's1',
      title: 'تصميم شعار احترافي',
      description: 'تصميم شعار احترافي يعكس هوية علامتك التجارية',
      price: 500,
      deliveryTime: 3,
      rating: 4.8,
      reviewsCount: 124,
      image: 'https://images.unsplash.com/photo-1626785774573-4b799315345d?w=400',
      supplier: {
        id: 'sup1',
        name: 'أحمد المصمم',
        avatar: 'https://i.pravatar.cc/150?img=1',
        isVerified: true,
      },
    },
  ],
  suppliers: [
    {
      id: 'sup1',
      name: 'أحمد المصمم',
      avatar: 'https://i.pravatar.cc/150?img=1',
      serviceDescription: 'مصمم جرافيك محترف',
      rating: 4.9,
      totalReviews: 156,
      completedProjects: 245,
      isVerified: true,
    },
  ],
};

// Mock service for edit page
export const mockServiceForEdit = {
  id: 's1',
  title: 'تصميم شعار احترافي',
  description: 'تصميم شعار احترافي يعكس هوية علامتك التجارية',
  category: 'design',
  price: 500,
  deliveryTime: 3,
  revisions: '2',
  features: ['3 مفاهيم تصميم أولية', 'مراجعتين مجانيتين', 'ملفات بصيغ متعددة'],
  images: [
    'https://images.unsplash.com/photo-1626785774573-4b799315345d?w=400',
    'https://images.unsplash.com/photo-1561070791-2526d30994b5?w=400',
  ],
};

// Categories for service forms
export const serviceCategories = [
  { id: 'design', name: { ar: 'تصميم', en: 'Design' } },
  { id: 'development', name: { ar: 'برمجة وتطوير', en: 'Development' } },
  { id: 'content', name: { ar: 'كتابة محتوى', en: 'Content Writing' } },
  { id: 'marketing', name: { ar: 'تسويق', en: 'Marketing' } },
];
